import { get as apiGet } from 'api'

export const GetMassJobs = async tableState => apiGet('/MassJobs', tableState)
export const GetMassJobTasks = async (id, tableState) => apiGet(`/MassJobs/${id}/Tasks`, tableState)
